import type { CdpImportedListingRow } from '@tcvs/shared';

export type ReconciliationSummary = Record<
  'full-sku' | 'numeric-prefix' | 'missing' | 'ambiguous',
  number
>;

export function reconciliationSummaryText(summary: ReconciliationSummary): string {
  return `${summary['full-sku']} exact, ${summary['numeric-prefix']} legacy-prefix, ${summary.missing} missing, ${summary.ambiguous} ambiguous`;
}

export function importReviewRows(
  rows: readonly CdpImportedListingRow[],
  onlyNeedsReview: boolean,
): readonly CdpImportedListingRow[] {
  return onlyNeedsReview ? rows.filter((row) => row.reviewStatus === 'NEEDS_REVIEW') : rows;
}
